module.exports = __webpack_public_path__ + "img/1.7e43fca3.png";